import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useObserver } from 'mobx-react-lite';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import { useProductFiltersApplied } from 'hooks/use-product-filters-applied';
import useSpecialGamification from 'src/dispensary/hooks/use-special-gamification';
import useDispensarySpecials from 'src/dispensary/hooks/use-dispensary-specials';
import useCart from 'src/hooks/use-cart';
import { mediaQueries } from 'shared/styles';
import Menu from 'components/menu';
import ContentWrapper from 'components/core/content-wrapper';
import { Offer } from 'components/special-card/offer';

export default function BogoPage() {
  const router = useRouter();
  const { dispensary } = useDispensary();
  const { specialId } = router.query;

  const flags = useFlags();
  const isGamificationFlagEnabled = flags['consumer.ecomm.gamification.rollout'] ?? false;

  const { products, totalPages, loading } = useDispensaryProducts({
    filters: { specialId, specialType: `bogo`, isOnSpecial: true },
  });

  const productFiltersApplied = useProductFiltersApplied();
  const displaySidebar = !(_.isEmpty(products) && !productFiltersApplied);

  const cart = useCart();
  const cartDiscountGamificationDetails = useObserver(() => cart.discountGamificationDetails);

  const { specials } = useDispensarySpecials({ specialId });
  const { gamificationThresholds } = useSpecialGamification({
    specialIds: [specials?.[0]?.sourceId],
    skip: !specials.length,
  });

  if (!dispensary) {
    return null;
  }

  const gamifiedSpecial = gamificationThresholds?.[0];
  const matchingCartDiscountGamification = cartDiscountGamificationDetails?.find(
    (offer) => offer.specialId === specialId
  );

  const belowHeaderComponent =
    isGamificationFlagEnabled && gamifiedSpecial ? (
      <OfferMarginShiftContainer>
        <Offer
          specialId={specialId}
          specialName={specials?.[0]?.name}
          thresholdType={gamifiedSpecial.satisfiers[0].thresholdType}
          threshold={gamifiedSpecial.satisfiers[0].minimumThreshold}
          currentAmount={matchingCartDiscountGamification?.thresholds[0]?.currentAmount ?? 0}
          cartItemIds={matchingCartDiscountGamification?.thresholds[0]?.applicableProducts ?? []}
          shouldDisplayItems
        />
      </OfferMarginShiftContainer>
    ) : null;

  return (
    <ContentWrapper>
      <Menu
        products={products}
        loading={loading}
        dispensary={dispensary}
        page='bogo special'
        specialId={specialId}
        specialType='bogo'
        skipCurrentFilters
        totalPages={totalPages}
        displaySidebar={displaySidebar}
        belowHeaderComponent={belowHeaderComponent}
      />
    </ContentWrapper>
  );
}

// This is heinous, but the special header image is going to change soon so no reason to rework it now
const OfferMarginShiftContainer = styled.div`
  margin: -${55 - 8}px 0 40px;

  @media ${mediaQueries.phone} {
    margin: -${24 - 8}px 0 ${24 - 11}px;
  }
`;
